export const setQueryParams = (params) => {
  const queryParams = new URLSearchParams(window.location.search);

  for (const key in params) {
    queryParams.set(key, params[key]);
  }

  history.pushState(null, null, '?' + queryParams.toString());
};
